const ContactNumber = (props) => {
  return (
    <>
      <p>{props.phone}</p>
    </>
  );
};

export default ContactNumber;
